import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import buttons from '../../../styles/shared/buttons.module.css';
import card from '../../../styles/shared/publicCard.module.css';
import styles from './HomePage.module.css';

export default function HomePage() {
  const [slug, setSlug] = useState('');
  const navigate = useNavigate();

  function go(e) {
    e.preventDefault();
    const s = slug.trim();
    if (s) navigate(`/o/${encodeURIComponent(s)}`);
  }

  return (
    <div className={card.centeredPage}>
      <h1>PulseLoop</h1>
      <p>Free food alerts. Enter your organization to see what&apos;s on.</p>
      <form onSubmit={go} className={styles.form}>
        <InputText
          type="text"
          placeholder="organization-slug"
          value={slug}
          onChange={(e) => setSlug(e.target.value)}
          aria-label="Organization slug"
        />
        <Button type="submit" label="Go" className={buttons.btnPrimary} />
      </form>
    </div>
  );
}
